import React, {useContext, useEffect, useState} from 'react';

import AppStateContext from "../../context/appStateContext";

import FormInputSection from "../../../components/formInputSection";
import FormInput from "../../../components/formInput";
import DataListInput from "../../../components/DataListInput";
import InputText from "../../../components/inputText";

interface UserInfoFormInputProps {
  inputs: {
    name: string,
    contractNo: string,
    phone: string,
    department: string,
  },
  handleMultipleInput: (name, type) => {},
  handleInputChange: (input) => {},
}

const UserInfoFormInput: React.FC<UserInfoFormInputProps> = ({inputs, handleMultipleInput, handleInputChange}) => {
  const { contractCallers, contractDepartments } = useContext(AppStateContext);

  const changeUserInfo = (event: any) => {
    let selectedName;
    let targetInfo = contractCallers[inputs.contractNo].find((caller: {
      ContactName: string,
    }) => {
      return caller.ContactName == event.target.value;
    });
    if (event.target.value != '' && targetInfo != undefined) {
      selectedName = targetInfo;
    } else {
      selectedName = { ContactPhone: '', ContactName: event.target.value };
    }
    handleMultipleInput(selectedName, 'user info');
  };

  return (
    <FormInputSection title='Your Information' number={2}>
      <FormInput title='First & Last name'>
        {contractCallers[inputs.contractNo] != undefined? <DataListInput
            text=""
            placeholder=""
            value={inputs.name}
            id="contactName"
            onChange={changeUserInfo}
          >
            {contractCallers[inputs.contractNo].map((item: {
              ContactName: string,
            }) => {
              return <option value={item.ContactName} />;
            })}
          </DataListInput> :
          <InputText
            text=""
            placeholder=''
            value={inputs.name}
            name="name"
            onChange={handleInputChange}
            missing={false}
          />
        }
      </FormInput>
      <FormInput title='Phone number'>
        <InputText
          text=""
          name="phone"
          value={inputs.phone}
          onChange={handleInputChange}
          placeholder="021 123123"
          missing={false}
        />
      </FormInput>
      <FormInput title="Department">
        {
          contractDepartments[inputs.contractNo] != undefined? <DataListInput
            text=""
            placeholder=""
            value={inputs.department}
            id="department"
            onChange={handleInputChange}>
              {contractDepartments[inputs.contractNo].map((department: {
                Department: string,
                Description: string,
              }) => {
                return <option value={department.Department}>{department.Description}</option>
              })}
            </DataListInput>
            :
            <InputText text="" placeholder="" value={inputs.department} name='department' missing={false} onChange={handleInputChange}/>
        }
      </FormInput>
    </FormInputSection>
  )
};

export default UserInfoFormInput;